/**
 * 「訂單建立中」空狀態背景輪詢的時間／條件邏輯。
 *
 * 情境：LIFF 網頁收不到 push，瓦斯行後台晚點才建單，客戶停在「訂單建立中」空狀態時，
 * 原本只有按「重新整理」才會重新查詢，容易被誤以為卡住。這裡把「這一刻該不該靜默查一次」
 * 抽成純函式，方便單元測試涵蓋所有條件組合，實際的 timer／DOM 事件留給呼叫端的 hook。
 */

/** 背景輪詢間隔：每 5 秒查一次。 */
export const PENDING_POLL_INTERVAL_MS = 5 * 1000;

/** 單一輪詢工作階段的最長持續時間；超過後自動停止背景輪詢（手動按「重新整理」仍可用）。 */
export const PENDING_POLL_MAX_DURATION_MS = 10 * 60 * 1000;

export interface ShouldPollInput {
  /** 分頁是否可見（document.visibilityState === "visible"）；不可見時暫停輪詢。 */
  visible: boolean;
  /** 是否已有查詢在進行中（含手動按「重新整理」觸發的），true 時本次跳過，避免重疊請求。 */
  inFlight: boolean;
  /** 這次輪詢工作階段開始的時間戳（ms）；null 表示尚未開始或已停止（例如條件尚未就緒）。 */
  startedAt: number | null;
  /** 目前時間戳（ms），呼叫端傳入以便測試注入固定時間。 */
  now: number;
}

/**
 * 判斷這一刻是否該送出一次背景查詢。純函式，不碰 timer／DOM。
 */
export const shouldPoll = ({ visible, inFlight, startedAt, now }: ShouldPollInput): boolean => {
  if (!visible) return false;
  if (inFlight) return false;
  if (startedAt === null) return false;
  if (now - startedAt >= PENDING_POLL_MAX_DURATION_MS) return false;
  return true;
};
